import React, { useState } from 'react';
import { Box, Stack } from '@mui/material';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { drawerWidth, layoutPageBg, topBarHeight } from './kobraLayoutTokens';

export const AppShell = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: layoutPageBg }}>
      <TopBar onMenuClick={handleDrawerToggle} />
      <Sidebar mobileOpen={mobileOpen} onMobileClose={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: layoutPageBg,
          overflow: 'auto',
          pt: `${topBarHeight}px`,
          pl: { md: `${drawerWidth}px` },
          transition: 'padding-left .2s ease',
        }}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: { xs: 2, sm: 3 },
            pb: 5,
            maxWidth: '100%',
          }}
        >
          {children}
        </Stack>
      </Box>
    </Box>
  );
};

